/* eslint-disable react-hooks/exhaustive-deps */
import "./CSS/ProfileScreen.css";
import { useEffect, useRef, useState } from "react";
import ProfileDetailsView from "./Views/ProfileDetailsView";
import appIcon from "../../assets/images/header-app-icon.svg";
import uploadIcon from "../../assets/images/profile-screen-upload-icon.svg";
import editProfilePic from "../../assets/images/profile-screen-edit-profile-icon.svg";
import leftWhiteIcon from "../../assets/images/dashboard-left-white.svg";
import leftOrengeIcon from "../../assets/images/dashboard-left-orenge.svg";
import rightWhiteIcon from "../../assets/images/dashboard-right-white.svg";
import rightOrengeIcon from "../../assets/images/dashboard-right-orenge.svg";
import {
  CALENDAR_RESERVATION_TYPE,
  MENU_ITEM,
  PROFILE_STATUS,
  PROFILE_STATUS_TYPE,
} from "utils/constants";
import { useStorage } from "services/StorageProvider";
import useWSMApi from "services/api/useWSMApi";
import { useMutation, useQuery } from "@tanstack/react-query";
import ActiveMemberLineupView from "screens/Profile Screen/Views/ActiveMemberLineupView";
import InActiveMemberLineupView from "screens/Profile Screen/Views/InActiveMemberLineupView";
import ROUTE_PATHS from "utils/routePaths";
import { useNavigate } from "react-router-dom";
import BecomeMemberDialog from "components/elements/BecomeMemberDialog";
import { useTabBar } from "services/TabBarProvider";
import SelectProfilePicDialog from "components/elements/SelectProfilePicDialog";
import AppLoader from "components/elements/AppLoader";
import { STORAGE_KEY } from "utils/strings";

const ProfileScreen = () => {
  const navigate = useNavigate();
  const { setSelectedTabBar } = useTabBar();
  const { fetchAllReservations, fetchWSMSlotById, fetchS3File } = useWSMApi();
  const eventsContainerRef = useRef<HTMLDivElement>(null);
  const [isActiveMember, setIsActiveMember] = useState<boolean>(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [showUploadPicDialog, setShowUploadPicDialog] =
    useState<boolean>(false);
  const { userProfileData, refreshUserProfile } = useStorage();
  const [showBecomeMemberDialog, setShowBecomeMemberDialog] =
    useState<boolean>(false);
  const [selectedReservation, setSelectedReservation] = useState<any>(null);
  const [profileImageUrl, setProfileImageUrl] = useState<string | null>(null);
  const [isImgLoading, setIsImgLoading] = useState(true);

  useEffect(() => {
    if (!profileImageUrl) return;
    setIsImgLoading(true);
    const img = new Image();
    img.src = profileImageUrl;
    img.onload = () => setIsImgLoading(false);
    img.onerror = () => setIsImgLoading(false);
  }, [profileImageUrl]);

  const { data: reservationsData } = useQuery({
    queryKey: ["fetch-user-reservations"],
    queryFn: () => fetchAllReservations(),
    retry: false,
  });

  const porfilePicMutation = useMutation({
    mutationFn: () => fetchS3File(userProfileData?.profile_pic),
    onSuccess: (response) => {
      setProfileImageUrl(response?.imageUrl);
    },
  });

  useEffect(() => {
    if (!showUploadPicDialog) {
      porfilePicMutation.mutate();
    }
  }, [showUploadPicDialog]);

  useEffect(() => {
    refreshUserProfile();
    setIsActiveMember(
      userProfileData?.credit?.status === PROFILE_STATUS.MEMBER,
    );
  }, []);

  useEffect(() => {
    updateScrollButtons();
    const el = eventsContainerRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);
    return () => {
      el.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, []);

  const getServiceSlotMutation = useMutation({
    mutationFn: (slotId: string) => fetchWSMSlotById(slotId),
    onSuccess: (response) => {
      localStorage.setItem(
        STORAGE_KEY.SELECTED_RESERVATION_DATA,
        JSON.stringify(selectedReservation),
      );
      localStorage.setItem(
        STORAGE_KEY.SELECTED_SLOT_DATA,
        JSON.stringify(response),
      );
      if (response.service_type === CALENDAR_RESERVATION_TYPE.RETREAT) {
        navigate(
          ROUTE_PATHS.WSM_RETREAT_DETAIL.replace(":slotId", response?.id),
        );
      } else {
        navigate(
          ROUTE_PATHS.WSM_WORKSPACE_DETAIL.replace(":slotId", response?.id),
        );
      }
    },
  });

  const updateScrollButtons = () => {
    const el = eventsContainerRef.current;
    if (el) {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }
  };

  const scrollEvents = (direction: "left" | "right") => {
    if (eventsContainerRef.current && isActiveMember) {
      const scrollAmount = 200;
      eventsContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
      setTimeout(updateScrollButtons, 300);
    }
  };

  const handleUnlockItClick = () => {
    if (userProfileData?.credit?.status === PROFILE_STATUS.PAYMENT_PENDING) {
      setSelectedTabBar(MENU_ITEM.MEMBERSHIP);
    } else if (userProfileData?.credit?.status === PROFILE_STATUS.MEMBER) {
      setSelectedTabBar(MENU_ITEM.CALENDAR);
    } else {
      setShowBecomeMemberDialog(true);
    }
  };

  const handleURLineUpCardClick = (event: any) => {
    setSelectedReservation(event);
    getServiceSlotMutation.mutate(event?.service_slot_id);
  };

  return (
    <div className="wms-mobile-container">
      <header className="profile-screen-header-header-bar">
        <div className="profile-screen-header-left-container">
          <img src={appIcon} alt="logo" />
        </div>
        <div className="profile-screen-header-divider"></div>
        <div className="profile-screen-header-right-container">
          Profile
        </div>
      </header>
      <div className="profile-screen-header-container">
        <div
          className="profile-pic-container"
          style={{
            backgroundImage:
              !isImgLoading && profileImageUrl
                ? `url(${profileImageUrl})`
                : "none",
          }}
        >
          {isImgLoading ? (
            <div className="loader-conatiner">
              <AppLoader />
            </div>
          ) : userProfileData?.profile_pic ? (
            <img
              src={editProfilePic}
              alt="edit-profile-pic"
              className="edit-icon"
              onClick={() => setShowUploadPicDialog(true)}
            ></img>
          ) : (
            <div className="upload-profile-container">
              <img src={uploadIcon} alt="upload-icon" />
              <button onClick={() => setShowUploadPicDialog(true)}>
                Upload Profile Picture
              </button>
              <span>JPEG, PNG up to 5MB</span>
            </div>
          )}

          <div
            className="profile-screen-header-detail-container"
            style={{
              backgroundColor: !userProfileData?.profile_pic
                ? "#2a2a2d"
                : "rgba(28, 28, 30, 0.7)",
            }}
          >
            <div className="left-container">
              <span>{userProfileData?.first_name} </span>
              <span style={{ color: "#C2B58C" }}>
                {userProfileData?.last_name}
              </span>
            </div>
            <div className="profile-screen-membership-container">
              {
                PROFILE_STATUS_TYPE.find(
                  (type) => type.value === userProfileData?.credit?.status,
                )?.name
              }
            </div>
          </div>
        </div>
      </div>
      {reservationsData?.data?.content?.length > 0 ? (
        <div className="profile-screen-ur-line-up-container">
          <div className="header-container">
            <div className="header-title">
              ur <span style={{ color: "#C2B58C" }}>lineup</span>
            </div>
            <div className="button-container">
              <img
                src={canScrollLeft ? leftOrengeIcon : leftWhiteIcon}
                alt="left-button"
                onClick={() => canScrollLeft && scrollEvents("left")}
              />
              <img
                src={canScrollRight ? rightOrengeIcon : rightWhiteIcon}
                alt="right-button"
                onClick={() => canScrollRight && scrollEvents("right")}
              />
            </div>
          </div>
          <div className="divider"></div>
          <div className="profile-screen-ur-line-up-events-container-events-wrapper">
            <div
              className="profile-screen-ur-line-up-events-container"
              ref={eventsContainerRef}
            >
              {reservationsData?.data?.content?.map(
                (event: any, index: number) => (
                  <ActiveMemberLineupView
                    key={index}
                    event={event}
                    onClick={() => handleURLineUpCardClick(event)}
                  />
                ),
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="profile-screen-ur-line-up-container">
          <div className="header-container">
            <div className="header-title">
              ur <span style={{ color: "#C2B58C" }}>lineup</span>
            </div>
            <div className="button-container">
              <img src={leftWhiteIcon} alt="left-button" />
              <img src={rightWhiteIcon} alt="right-button" />
            </div>
          </div>
          <div className="divider"></div>
          <div className="profile-screen-ur-line-up-events-container-events-wrapper">
            <div
              className="profile-screen-ur-line-up-events-container"
              ref={eventsContainerRef}
            >
              {[{}, {}, {}].map((_: any, index: number) => (
                <InActiveMemberLineupView key={index} />
              ))}
            </div>
            <div className="profile-screen-ur-line-up-events-container-blur-overlay">
              <button onClick={handleUnlockItClick}>Unlock It</button>
            </div>
          </div>
        </div>
      )}
      <ProfileDetailsView isActiveMember={isActiveMember} />
      <BecomeMemberDialog
        profileStatus={userProfileData?.credit?.status}
        open={showBecomeMemberDialog}
        onClose={() => setShowBecomeMemberDialog(false)}
      />
      <SelectProfilePicDialog
        open={showUploadPicDialog}
        onClose={() => setShowUploadPicDialog(false)}
      />
    </div>
  );
};

export default ProfileScreen;
